import styled from "styled-components";
import { BREAKPOINTS, desktop, mobile } from "../../variables/Breakpoints";
import { setFlex, setPosition } from "../../variables/Position";
import { cursor } from "../../variables/Cursors";

export const Wrapper = styled.div`
  ${setPosition({ position: "relative" })};
  ${setFlex({ align: "center", direction: "column" })};
  min-height: 125vh;
  padding: 2rem;
  @media (max-width: ${BREAKPOINTS.md}px) {
    padding: 1.2rem;
  }
  @media (max-width: ${BREAKPOINTS.sm}px) {
    min-height: 75vh;
    padding: 0;
  }
`;

export const ImageContainer = styled.div`
  ${setFlex({ justify: "center", align: "center" })};
  ${setPosition({ zIndex: "0" })};
  @media (max-width: ${BREAKPOINTS.sm}px) {
    padding: 1.2rem;
  }
`;

export const Image = styled.img`
  width: auto;
  max-width: 100%;
  ${props =>
    props.$blend &&
    `
    ${setPosition({ position: "absolute", zIndex: 1 })};
    mix-blend-mode: multiply;
  `};
  ${props => props.$desktop && desktop};
  ${props => props.$mobile && mobile};
`;

export const QuoteContainer = styled.div`
  ${setPosition({ position: "absolute" })};
  ${setFlex({ justify: "center", align: "center" })};
  top: 35%;
  @media (max-width: ${BREAKPOINTS.md}px) {
    top: 50%;
  }
  @media (max-width: ${BREAKPOINTS.sm}px) {
    ${setPosition({ position: "relative" })};
    top: unset;
  }
`;

export const ImageLink = styled.a`
  ${cursor("pointer")};
`;
